export interface ILiteral {
  value: string
  fallback: string
}

export type LiteralParams = Record<string, string | number>

export const formatLiteral = (text: string, params?: LiteralParams) =>
  text.replace(/\{(\w+)\}/g, (placeholder, name) =>
    params && params[name] != null ? String(params[name]) : placeholder
  )

export function resolveLiteral(
  text: string | ILiteral,
  dictionary?: Partial<Record<string, string>>,
  params?: LiteralParams
) {
  const key = typeof text === 'string' ? text : text.value
  const translated = dictionary?.[key]
  // Keep legacy string-key behavior; descriptors additionally reject untranslated key placeholders.
  const value =
    typeof text === 'string'
      ? translated || key
      : typeof translated === 'string' && translated.trim() && translated !== key
      ? translated
      : text.fallback
  return formatLiteral(value, params)
}
